import { useState } from "react";
import { Loader2, Send, BadgeDollarSign } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";
import { money } from "@/lib/landingSim";

const errMsg = (err, f) => { const d = err.response?.data?.detail; return Array.isArray(d) ? d.map(e => e.msg).join(", ") : d || f; };

export const ZellePayments = ({ planId, inv, isAdmin, approved, zelleSent, note, onChange }) => {
  const due = inv.status === "unpaid" ? inv.deposit_due : inv.balance;
  const [amount, setAmount] = useState(String(due || ""));
  const [ref, setRef] = useState("");
  const [busy, setBusy] = useState("");
  if (inv.balance < 0.5) return null;
  const send = async () => {
    setBusy("send");
    try { const { data } = await api.post(`/api/webadvisor/plan/${planId}/zelle-invoice`, { origin_url: window.location.origin, note }); toast.success(data.message); onChange(); }
    catch (err) { toast.error(errMsg(err, "Send failed")); } finally { setBusy(""); }
  };
  const record = async () => {
    if (!window.confirm(`Record a ${money(Number(amount))} Zelle payment? Only do this after it shows in your bank.`)) return;
    setBusy("record");
    try { const { data } = await api.post(`/api/webadvisor/plan/${planId}/manual-payment`, { amount: Number(amount), method: "zelle", reference: ref }); toast.success(data.message); setRef(""); onChange(); }
    catch (err) { toast.error(errMsg(err, "Couldn't record payment")); } finally { setBusy(""); }
  };
  return (
    <div className="bg-violet-50/60 border border-violet-200 rounded-lg p-3 space-y-3" data-testid="zelle-payments">
      <div className="flex flex-wrap items-center gap-2">
        <button onClick={send} disabled={!!busy || !approved} className="bg-violet-600 hover:bg-violet-500 text-white text-sm font-bold px-4 py-2 rounded-lg flex items-center gap-1.5 disabled:opacity-50" data-testid="zelle-invoice-btn">
          {busy === "send" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Send Zelle invoice · {money(due)}
        </button>
        {zelleSent && <span className="text-xs text-violet-700" data-testid="zelle-invoice-info">Sent {zelleSent.sent_at.slice(0, 10)} to {zelleSent.sent_to}</span>}
      </div>
      {isAdmin && (
        <div className="flex flex-wrap items-end gap-2">
          <label className="text-[11px] text-slate-500">Amount received<Input type="number" value={amount} onChange={e => setAmount(e.target.value)} className="h-8 w-32 text-sm bg-white" data-testid="zelle-record-amount" /></label>
          <label className="text-[11px] text-slate-500">Zelle reference (optional)<Input value={ref} onChange={e => setRef(e.target.value)} className="h-8 w-48 text-sm bg-white" data-testid="zelle-record-ref" /></label>
          <button onClick={record} disabled={!!busy || !(Number(amount) > 0)} className="h-8 bg-slate-900 hover:bg-slate-700 text-white text-xs font-bold px-3 rounded-md flex items-center gap-1 disabled:opacity-50" data-testid="zelle-record-btn">
            {busy === "record" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <BadgeDollarSign className="w-3.5 h-3.5" />}Mark Zelle payment received
          </button>
        </div>
      )}
    </div>
  );
};
